import _typeof from "@babel/runtime/helpers/typeof";
import { createVNode as _createVNode } from "vue";
import { defineComponent, h } from 'vue';
import Abstract from '../abstract';
import { Device } from '../utils';
import { Row as ARow, Col as ACol } from 'ant-design-vue';
// eslint-disable-next-line complexity
var formatColConfig = function formatColConfig(config) {
  var _xl2, _lg, _md, _sm, _xs;
  var xs = config.xs,
    sm = config.sm,
    md = config.md,
    lg = config.lg,
    xl = config.xl,
    xxl = config.xxl;
  if (xxl === undefined) {
    var _ref, _ref2, _ref3, _ref4, _xl;
    xxl = (_ref = (_ref2 = (_ref3 = (_ref4 = (_xl = xl) !== null && _xl !== void 0 ? _xl : lg) !== null && _ref4 !== void 0 ? _ref4 : md) !== null && _ref3 !== void 0 ? _ref3 : sm) !== null && _ref2 !== void 0 ? _ref2 : xs) !== null && _ref !== void 0 ? _ref : 1;
  }
  xl = (_xl2 = xl) !== null && _xl2 !== void 0 ? _xl2 : xxl;
  lg = (_lg = lg) !== null && _lg !== void 0 ? _lg : xl;
  md = (_md = md) !== null && _md !== void 0 ? _md : lg;
  sm = (_sm = sm) !== null && _sm !== void 0 ? _sm : md;
  xs = (_xs = xs) !== null && _xs !== void 0 ? _xs : sm;
  return {
    xs: xs,
    sm: sm,
    md: md,
    lg: lg,
    xl: xl,
    xxl: xxl
  };
};
var colVertical = function colVertical(itemList, col) {
  var colList = [];
  for (var i = 0, bIndex = 0, rest = itemList.length, capacity = Math.ceil(rest / col); i < col; i++) {
    colList[i] = colList[i] || [];
    for (var j = 0; j < capacity; j++) {
      colList[i][j] = itemList[bIndex + j];
      rest--;
    }
    bIndex += capacity;
    capacity = Math.ceil(rest / (col - i - 1));
  }
  return colList;
};
var colHorizontal = function colHorizontal(itemList, col) {
  var colList = [];
  for (var j = 0; j < itemList.length; j++) {
    var _colList$colIndex;
    var colIndex = j % col;
    colList[colIndex] = (_colList$colIndex = colList[colIndex]) !== null && _colList$colIndex !== void 0 ? _colList$colIndex : [];
    colList[colIndex][Math.floor(j / col)] = itemList[j];
  }
  return colList;
};
export default defineComponent({
  name: 'StreamLayout',
  extends: Abstract,
  props: {
    col: {
      type: [Number, Object],
      default: 1
    },
    gutter: {
      type: [Number, Object],
      default: 16
    },
    direction: {
      type: String,
      default: 'horizontal'
    }
  },
  data: function data() {
    return {
      className: 'stream-layout',
      deviceType: 'lg'
    };
  },
  computed: {
    colConfig: function colConfig() {
      var col = this.col;
      if (typeof col === 'number') {
        return {
          xs: col,
          sm: col,
          md: col,
          lg: col,
          xl: col,
          xxl: col
        };
      } else {
        return formatColConfig(col);
      }
    },
    gutterConfig: function gutterConfig() {
      var gutter = this.gutter;
      if (typeof gutter === 'number') {
        return {
          x: gutter,
          y: gutter
        };
      } else {
        return gutter;
      }
    },
    colNum: function colNum() {
      return this.colConfig[this.deviceType];
    }
  },
  created: function created() {
    var _this = this;
    // 监听设备尺寸变化
    Device.deviceEnquire(function (type) {
      _this.deviceType = type;
    });
  },
  methods: {
    renderCols: function renderCols(children, direction) {
      var colNum = this.colNum,
        gutterConfig = this.gutterConfig,
        prefixCls = this.prefixCls;
      var xGutter = gutterConfig.x,
        yGutter = gutterConfig.y;
      var _yGutter = Math.floor(yGutter / 2);
      var itemList = children.map(function (item) {
        return _createVNode("div", {
          "class": "".concat(prefixCls, "-item"),
          "style": "padding: ".concat(_yGutter, "px 0px;")
        }, [item]);
      });
      var colList = direction === 'vertical' ? colVertical(itemList, colNum) : colHorizontal(itemList, colNum);
      var span = Math.floor(24 / colNum);
      var cols = colList.map(function (item) {
        return h(ACol, {
          class: "".concat(prefixCls, "-col"),
          style: "margin: -".concat(_yGutter, "px 0px;"),
          span: span
        }, function () {
          return item;
        });
      });
      return h(ARow, {
        gutter: xGutter,
        class: prefixCls
      }, function () {
        return cols;
      });
    }
  },
  render: function render() {
    var direction = this.direction,
      $slots = this.$slots,
      colNum = this.colNum;
    var children = $slots.default && $slots.default();
    if (children && children.length > 0 && colNum > 0) {
      // fix symbol component's problem
      var _children = children === null || children === void 0 ? void 0 : children.flatMap(function (item) {
        if (_typeof(item.type) === 'symbol') {
          return item.children;
        }
        return item;
      });
      return this.renderCols(_children, direction);
    }
    return children;
  }
});